import Axios from "axios";
import { AxiosClient } from "../../utils/axios";
import { logError } from "../../utils/logError";
export const state = () => ({
  listGroupMajor: [],
  listRawGroupMajor: [],
  listGroupByNameGroup: [],
  listGroupByMajorName: [],
  listBenchmark: {},
  benchmarkLoading: false,
  majorLoading: true,
});

export const mutations = {
  SET_LIST_GROUP_MAJOR(state, payload) {
    state.listGroupMajor = payload;
  },
  SET_LIST_RAW_GROUP_MAJOR(state, payload) {
    state.listRawGroupMajor = payload;
  },
  SET_LIST_GROUP_BY_NAME_GROUP(state, payload) {
    state.listGroupByNameGroup = payload;
  },
  SET_LIST_GROUP_BY_MAJOR_NAME(state, payload) {
    state.listGroupByMajorName = payload;
  },
  SET_LIST_BENCHMARK(state, payload) {
    state.listBenchmark = payload;
  },
  SET_MAJOR_LOADING(state, payload) {
    state.majorLoading = payload;
  },

  SET_BENCHMARK_LOADING(state, payload) {
    state.benchmarkLoading = payload;
  },
};
export const actions = {
  async getListGroupMajor({ commit, rootState }) {
    commit("SET_MAJOR_LOADING", true);
    try {
      const domain = this.$config.BASE_URL_CLIENT;
      const res = await Axios.get(
        `${domain}/api/majors/get-list-group-major`,
        {}
      );
      const { data, code, message, rawData } = res.data;
      if (code == 200) {
        commit("SET_LIST_GROUP_MAJOR", data);
        commit("SET_LIST_RAW_GROUP_MAJOR", rawData);
      }
    } catch (error) {
      logError(error, "getListGroupMajor on store");
    }
    commit("SET_MAJOR_LOADING", false);
  },

  async getListGroupMajorBySchoolId({ commit, rootState }, payload) {
    commit("SET_MAJOR_LOADING", true);
    try {
      const params = {
        school_id: payload.school_id,
        page: payload.page,
        ...(payload.major_name && { major_name: payload.major_name }),
      };
      const domain = this.$config.BASE_URL_CLIENT;
      // const res = await AxiosClient.get(
      //   "/api/majors/get-list-group-major-by-school-id",
      //   { params }
      // );
      const res = await Axios.get(
        `${domain}/api/majors/get-list-group-major-by-school-id`,
        { params }
      );
      commit("SET_MAJOR_LOADING", false);
      return res.data.data;
      // const { data, code, message } = res.data;
      // if (code == 200) {
      //   commit("SET_LIST_GROUP_MAJOR", data);
      // }
    } catch (error) {
      commit("SET_MAJOR_LOADING", false);
      logError(error, "getListGroupMajorBySchoolId on store");
    }
  },

  async getListGroupByNameGroup({ commit, rootState }, nameGroup) {
    commit("SET_MAJOR_LOADING", true);
    try {
      const domain = this.$config.BASE_URL_CLIENT;
      // const res = await AxiosClient.post(
      //   `/api/majors/get-list-group-major-by-name-group`,
      //   { nameGroup },
      //   {}
      // );
      const res = await Axios.post(
        `${domain}/api/majors/get-list-group-major-by-name-group`,
        { nameGroup },
        {}
      );
      const { data, code, message } = res.data;
      if (code == 200) {
        commit("SET_LIST_GROUP_BY_NAME_GROUP", data);
      }
      commit("SET_MAJOR_LOADING", false);
    } catch (error) {
      commit("SET_MAJOR_LOADING", false);
      logError(error, "getListGroupByNameGroup on store");
    }
  },

  async getListGroupBySearchInput({ commit, rootState }, { search, group }) {
    commit("SET_MAJOR_LOADING", true);

    try {
      const domain = this.$config.BASE_URL_CLIENT;
      // const res = await AxiosClient.post(
      //   `/api/majors/get-list-group-major-by-search-input`,
      //   { search, group },
      //   {}
      // );
      const res = await Axios.post(
        `${domain}/api/majors/get-list-group-major-by-search-input`,
        { search, group },
        {}
      );
      const { data, code, message } = res.data;
      if (code == 200) {
        commit("SET_LIST_GROUP_BY_NAME_GROUP", data);
      }

      commit("SET_MAJOR_LOADING", false);
    } catch (error) {
      logError(error, "getListGroupBySearchInput on store");
    }
    commit("SET_MAJOR_LOADING", false);
  },

  async getListGroupByMajorName({ commit, rootState }, majorName) {
    commit("SET_MAJOR_LOADING", true);

    try {
      // const res = await AxiosClient.post(
      //   `/api/majors/get-list-group-major-by-major-name`,
      //   { majorName },
      //   {}
      // );
      const domain = this.$config.BASE_URL_CLIENT;
      const res = await Axios.post(
        `${domain}/api/majors/get-list-group-major-by-major-name`,
        { majorName },
        {}
      );
      const { data, code, message } = res.data;
      if (code == 200) {
        commit("SET_LIST_GROUP_BY_MAJOR_NAME", data);
      }
    } catch (error) {
      logError(error, "getListGroupByMajorName on store");
    }
    commit("SET_MAJOR_LOADING", false);
  },

  async getListBenchmark({ commit, rootState }, payload) {
    commit("SET_BENCHMARK_LOADING", true);

    try {
      const domain = this.$config.BASE_URL_CLIENT;
      // const result = await AxiosClient.get(
      //   "/api/majors/benchmark/get-list-benchmark",
      //   {
      //     params: {
      //       ...payload,
      //     },
      //   }
      // );
      const result = await Axios.get(
        `${domain}/api/majors/benchmark/get-list-benchmark`,
        {
          params: {
            ...payload,
          },
        }
      );

      if (result.data.success) {
        const metadata = result.data.metadata;

        const data = result.data.data;
        commit("SET_LIST_BENCHMARK", {
          data,
          metadata,
        });
      }
    } catch (error) {
      logError(error, "getListBenchmark on store");
    }
    commit("SET_BENCHMARK_LOADING", false);
  },
};
